const FormResources = {

    form_data:{
        staffing_scenario_id:   '',
        group_id:               '',
        daily_assignment_id: [],
        description:            '',
        frequency_week:         '',
        daily_minutes:          '',
        annual_minutes:         '', 
        from_assignment_notes:  0,
    },

    form_format:[
        {
            css_class:  'col-md-12',
            type:       'switch',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Create staffing fix from assignment notes:',
            model_name: 'from_assignment_notes',
            ref:        'from_assignment_notes_input',
            ref_alt:    'from_assignment_notes_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Group Name:',
            model_name: 'group_id',
            ref:        'group_id_input',
            ref_alt:    'group_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Frequency/Week:',
            model_name: 'frequency_week',
            ref:        'frequency_week_input',
            ref_alt:    'frequency_week_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Daily Minutes:',
            model_name: 'daily_minutes',
            ref:        'daily_minutes_input',
            ref_alt:    'daily_minutes_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-3',
            type:       'number',
            maxlength:  '',
            disabled:   true,
            step:       'any',
            name:       'Annual Minutes:',
            model_name: 'annual_minutes',
            ref:        'annual_minutes_input',
            ref_alt:    'annual_minutes_input_alt',
            required:   true,
        },
    ],

    form_format_2:[
        {
            css_class:  'col-md-12',
            type:       'switch',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Create staffing fix from assignment notes:',
            model_name: 'from_assignment_notes',
            ref:        'from_assignment_notes_input',
            ref_alt:    'from_assignment_notes_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Group Name:',
            model_name: 'group_id',
            ref:        'group_id_input',
            ref_alt:    'group_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Daily Assignment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select assignment(s)',
            close_on_option: false,
            track_by: 'name'
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Frequency/Week:',
            model_name: 'frequency_week',
            ref:        'frequency_week_input',
            ref_alt:    'frequency_week_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   true,
            step:       'any',
            name:       'Daily Minutes:',
            model_name: 'daily_minutes',
            ref:        'daily_minutes_input',
            ref_alt:    'daily_minutes_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   true,
            step:       'any',
            name:       'Annual Minutes:',
            model_name: 'annual_minutes',
            ref:        'annual_minutes_input',
            ref_alt:    'annual_minutes_input_alt',
            required:   true,
        },
    ]

}

export default FormResources;